<template>
  <div id="simple-calendar-app">
    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="calendarEvents"
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        locale="ar"
        :startingDayOfWeek="6"
        @click-date="dateClicked"
        @click-event="eventClicked">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
              <vs-button v-if="isTeacher" icon-pack="feather" icon="icon-plus" icon-after @click="openAddNewEvent(new Date())">حدث</vs-button>
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'" @click="updateMonth(-1)" svgClasses="w-5 h-5 m-1" class="cursor-pointer bg-primary text-white rounded-full" />
                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>
                <feather-icon :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'" @click="updateMonth(1)" svgClasses="w-5 h-5 m-1" class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                  <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                  <span>{{ label.text }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

    <!-- EVENT FORM -->
    <calendar-form v-if="Object.values(courses).length !== 0" :active.sync="isEventFormActive" :date="eventDate" />

    <!-- EVENT DATE -->
    <calendar-date @addEvent="openAddNewEvent" :data="calendarDateEvents" :date="dateEventsView" :active.sync="isCalendarDateActive" />
  </div>
</template>

<script>
    import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
    import moduleCalendar from '@/store/modules/calendar'
    require("vue-simple-calendar/static/css/default.css")

    import CalendarDate from '@/views/calendar/CalendarDate'
    import moment from 'moment'

    // TODO remove import store later
    import store from '@/store/store'
    import CalendarForm from './CalendarForm'

    export default {
        name: 'Calendar',
        components: {
            CalendarForm,
            CalendarDate,
            CalendarView,
            CalendarViewHeader,
        },
        data() {
            return {
                showDate: new Date(),

                calendarView: 'month',

                isEventFormActive: false,

                eventDate: '',

                calendarViewTypes: [
                    { label: "شهر", val: "month" },
                    { label: "اسبوع", val: "week" },
                    { label: "سنة", val: "year" },
                ],

                isCalendarDateActive: false,
                calendarDateEvents: [],
                dateEventsView: new Date(),
            }
        },
        computed: {
            courses(){
                return this.$store.state['courses']['all']
            },
            calendarEvents() {
                return this.$store.state.calendar.events
            },
            calendarLabels() {
                return this.$store.state.calendar.eventLabels
            },
            labelColor() {
                return (label) => {
                    if (label == "event") return "primary"
                    else if (label == "quiz") return "warning"
                    else if (label == "assignment") return "danger"
                }
            },
            windowWidth() {
                return this.$store.state.windowWidth
            }
        },
        methods: {
            dateClicked(payload){
                this.openDate(payload)
            },
            eventClicked(payload){
                this.openDate(payload.startDate)
            },
            openDate(date){
                this.calendarDateEvents = []
                const pickedDate = moment(date)
                this.calendarEvents.forEach(event => {
                    let eventDate = moment(event.startDate)
                    if(eventDate.isSame(pickedDate, 'day')){
                        event.color = this.labelColor(event.label)
                        this.calendarDateEvents.push(event)
                    }
                })
                this.dateEventsView = date
                this.isCalendarDateActive = true
            },
            updateMonth(val) {
                this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
            },
            openAddNewEvent(date) {
                if(Object.values(this.courses).length === 0) {
                    this.$notifyError('لا يمكنك إضافة حدث لانه لا يوجد لديك مواد دراسية.')
                    return
                }
                this.eventData = date;
                this.isEventFormActive = true;
            },
        },
        beforeRouteEnter(to, from, next) {
            store.registerModule('calendar', moduleCalendar)
            store.dispatch("calendar/fetchEvents").then(() => next())
        },
        beforeDestroy() {
            this.$store.unregisterModule('calendar')
        }
    }
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
